<template>
  <process-tabs ref="processTabsRef" processType="handCut" :tableData="tableData" :module="module" :daytime="daytime" @getTableData="getTableData" />
</template>

<script>
import ProcessTabs from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/ProcessTabs';

export default {
  components: { ProcessTabs },
  props: ['tableData', 'module', 'daytime'],
  name: 'HandCut',
  methods: {
    getTableData(searchForm) {
      this.$emit('getTableData', searchForm);
    },
    getSearchForm() {
      return this.$refs.processTabsRef?.getSearchForm();
    },
    resetFields() {
      this.$refs.processTabsRef?.resetFields();
    }
  }
};
</script>
